import axios from "infra/http";
import { useQuery } from "react-query";
import { TenantDetalhe } from "../typings/tenant";

function useGetTenant(tenantId?: string) {
  return useQuery(
    `/v1/tenants/${tenantId}`,
    async () => {
      const res = await axios.get<TenantDetalhe>(`/v1/tenants/${tenantId}`);

      return res.data;
    },
    {
      enabled: !!tenantId,
    }
  );
}

export default useGetTenant;
